<p>
  This opens the Climber App as the customer, where you can choose an upfront payment option and charge the membership's saved payment method. The purchased periods are added after the current paid-through date, so the next bill date moves out by that many periods.
</p>

<div class="alert alert-danger" role="alert" *ngIf="errorMessage">
  {{ errorMessage }}
</div>
